import axiosInstance from "../utils/axiosConfig";

const postGravarEventoMotorista = async (dadosEvento) => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest2/";
  const apiUrl = `${baseUrl}INT_APPMOTORISTA_INCLUSAOPAPELETA`;

  try {
    const response = await axiosInstance.post(apiUrl, dadosEvento, {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 10000, // Aumentar timeout para 10 segundos
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao fazer a requisição:", error);

    throw new Error("Houve um problema ao gravar o evento do motorista.");
  }
};

export { postGravarEventoMotorista };
